import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 14,
	viewBox: "0 0 9 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.646484 1.64639L2.0607 0.232178L8.76781 6.93928L2.0607 13.6464L0.646484 12.2322L5.93938 6.93928L0.646484 1.64639Z",
		fill: "#333333"
	})
});
export default SvgArrowRight;
